export interface EmailAcknowledgeStatusModel {
  status: 'FRESH' | 'ALREADY_ACKNOWLEDGED' | 'EXPIRED' | 'DELIVERY_FAILED';
  acknowledgeName?: string;
  acknowledgeTimestamp?: string;
  recipientEmail?: string;
  redirectUrl?: string;
  hasCustomLandingPage?: boolean;
}
